/**
 * Constants for BorrowerBank component
 */

import { BankFormErrors, BankFieldKey } from "./types";

/**
 * Initial empty error state
 */
export const INITIAL_ERRORS: BankFormErrors = {
  bankName: "",
  accountNumber: "",
  accountType: "",
  swiftCode: "",
  accountHolderName: "",
  bankAddress: "",
  bankCountry: "",
  currency: "",
};

/**
 * Validation configuration for required fields
 */
export const VALIDATION_RULES: Record<BankFieldKey, string> = {
  bankName: "Bank Name is required",
  accountNumber: "Account Number is required",
  accountType: "Account Type is required",
  swiftCode: "Swift Code is required",
  accountHolderName: "Account Holder Name is required",
  bankAddress: "Bank Address is required",
  bankCountry: "Bank Country is required",
  currency: "Currency is required",
};

/**
 * Toast messages
 */
export const TOAST_MESSAGES = {
  DRAFT_SAVED: "Draft Saved",
  ACCOUNT_HOLDER_MISMATCH: "Account holder name must match the company name",
  ACCOUNT_HOLDER_WARNING:
    "Account Holder Name should be the same as company name",
} as const;
